var _style, _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHandshake3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 451.1 313.2",
    style: {
      enableBackground: "new 0 0 451.1 313.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3D3D3;}\r\n\t.st1{opacity:0.5;fill:#430059;enable-background:new    ;}\r\n\t.st2{fill:#430059;}\r\n\t.st3{fill:#FA968C;}\r\n\t.st4{fill:#0E538C;}\r\n\t.st5{fill:#0B4870;}\r\n\t.st6{fill:#FAB9AF;}\r\n\t.st7{fill:#F7F7F7;}\r\n\t.st8{fill:#E8948B;}\r\n\t.st9{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: -486.2,
    cy: 362.8,
    rx: 304,
    ry: 29.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-547.3,1.4c-2.1,2-5.5,1.9-7.5-0.2l-37-38.8c-2-2.1-1.9-5.5,0.2-7.5l31-29.6c2.1-2,5.5-1.9,7.5,0.2l37,38.8 c2,2.1,1.9,5.5-0.2,7.5L-547.3,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-228.1-37.6c3,3.9,2.2,9.4-1.6,12.4l-71.1,54.6c-3.9,3-9.4,2.2-12.4-1.6l-43.6-56.9c-3-3.9-2.2-9.4,1.6-12.4 l71.1-54.6c3.9-3,9.4-2.2,12.4,1.6L-228.1-37.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -420.8,
    cy: -84.7,
    r: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -667.3,
    cy: 128.5,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-225,118.7c-14.4,3.3-28.6-5.7-31.9-20.1c0,0,0,0,0,0c-3.3-14.4,5.7-28.6,20.1-31.9c0,0,0,0,0,0 c14.4-3.3,28.6,5.7,31.9,20.1c0,0,0,0,0,0C-201.7,101.1-210.7,115.4-225,118.7z M-236.6,67.7c-13.8,3.1-22.4,16.8-19.3,30.6 c0,0,0,0.1,0,0.1c3.1,13.8,16.8,22.4,30.6,19.3c0,0,0.1,0,0.1,0c13.8-3.1,22.5-16.8,19.4-30.6c0,0,0-0.1,0-0.1 C-209,73.2-222.8,64.6-236.6,67.7C-236.6,67.7-236.6,67.7-236.6,67.7L-236.6,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-732.4,28c-16.1-16.8-15.5-43.6,1.3-59.7c0,0,0,0,0,0c16.9-16.1,43.6-15.5,59.7,1.4c0,0,0,0,0,0 c16.1,16.9,15.5,43.6-1.4,59.7c0,0,0,0,0,0C-689.6,45.4-716.3,44.8-732.4,28z M-672.1-29.7c-15.8-16.4-41.8-17-58.3-1.3 c-16.4,15.8-17,41.8-1.3,58.3c15.8,16.4,41.8,17,58.3,1.3C-657,12.8-656.4-13.2-672.1-29.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "woman"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-344.6,306.7c0,0,6.3,18.4,7.6,21.5c1.1,2.5,3.4,4.2,5.5,5.9c0.8,0.8,1.5,1.7,2,2.8c0.4,0.8,0.5,1.8,0.1,2.7 c-6.5,15.2-24.2,20.6-24.5,19.4c-0.6-2.1,2.2-6.2,5.9-8.2c3.7-2,6.2-5.8,6.5-10.1l0,0c0.3-3.4-0.3-6.7-1.7-9.8l-6.4-13.8 L-344.6,306.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-379.2,315.2l-2.4,19.6c-0.7,6,0.7,12.1,4.1,17.1l0,0c1.7,2.6,1,6-1.6,7.7c-0.2,0.1-0.4,0.3-0.6,0.4 c-9.9,4.7-29.1,13.6-30,12.9c-4.9-3.4,6.4-10.9,14.6-18.4c5.5-5.1,5.7-26.1,4.7-42.2l9.7,1.4C-380,314-379.5,314.5-379.2,315.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-392.6,359.8c-4.1,1.8-8.7,2.7-12.9,3.7c-0.5,0.1-1,0.3-1.3,0.7c-3.8,3.6-5.5,7-2.9,8.8 c0.9,0.6,16.5-0.8,27.2-11.6c0.4-0.5,1.7,5,1.7,5l5.3-1.2c0,0,0.6-9.4-0.5-11.1l-2.1-3.1C-382.5,354.5-387.4,357.5-392.6,359.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-368.8,108.2c11.3,2.5,20.6,17.1,18.1,32.4c-1.4,8.8-10.3,40.2-19.7,64.7c-3.7,9.6-2.5,20.4,3.4,28.9 c0.9,1.3,1.8,2.7,2.5,4.2c3.4,7.3,16,49.6,23.2,77.8c-0.8,3.6-2.9,8-5.5,9.4c-13.6-24.5-35.5-69-39.1-76.7 c-2.2-4.5-4.1-9.2-5.7-13.9c-8.9-13.6-4.8-85.9-2.5-100.1C-391.7,119.7-380.1,105.8-368.8,108.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9979 -6.453231e-02 6.453231e-02 0.9979 -1.7852 -23.4294)",
    className: "st4",
    cx: -363.6,
    cy: 15.9,
    rx: 17.5,
    ry: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-376.7-14.3c0,0-11.4,2.4-13.2,10.6c0,0-3.6-5.3-0.3-17.7C-387.8-30-376.7-14.3-376.7-14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-387.6,29.9c-0.4,8.8-1.1,17.6-2.3,26.4c-1.1,8.7-2.7,17.4-4.8,26c-2,8.6-4.7,17.1-8,25.3 c-1.7,4.1-3.7,8.1-5.9,12c-2.3,3.9-5,7.5-8.2,10.7c-0.5,0.5-1.3,0.5-1.8,0c0,0,0,0,0,0c-0.5-0.5-0.5-1.3-0.1-1.8l0,0 c5.4-6.5,8.9-14.4,11.7-22.5c2.6-8.2,4.7-16.5,6.1-25c1.4-8.5,2.5-17,3.1-25.6s1-17.2,1.1-25.8c0-2.5,2.1-4.5,4.6-4.5 c2.5,0,4.5,2.1,4.5,4.6L-387.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-396.9,79.7c-3.1-12.1,3.5-29.3,4.8-37.4c0.8-5.2-1.9-17-1.9-17l34.1,2.5c5.7,0.4,10,5.2,9.7,10.9 c-0.4,9.9-6.6,32-10.1,43.6L-396.9,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-389.9,316.5c-0.6-0.3-0.9-0.9-1-1.5c-1.8-25.1-3.4-57.1-3.5-63.3v-2.1c-8.3-29.1-15.4-92.6-17.1-103.7 c-2.2-14.6,5-32,16.3-33.7s24.8,8.9,29.8,21.9c3.3,8.6-1.3,56.7-8.1,91.8c-1.3,7.4-1.1,15,0.8,22.3c1.2,4.7,1.9,9.5,2,14.4 c0.1,6.1-4.2,31.2-8.5,52.8c-0.1,0.6-0.6,1.2-1.2,1.4C-383.4,318.1-386.9,318-389.9,316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-349.9,125l-7.5-27.3c-1.4-5.1-1.5-10.4-0.4-15.6c2.6-12,7.3-34.5,7.7-44.2c0.2-5.2-3.7-9.6-8.9-10l-5.1-0.4 c-2.4,4.8-7.6,7.6-12.9,7c-6.3-0.5-10.2-4.2-11.8-8.8l-4.7-0.3c4.3,11.4,1.4,25.9-8.1,33.7c1.2,6,2.2,11.9,2.9,16.8 c0.9,6.5-0.2,13.2-3.2,19.1c-5.1,10.1-9.8,26.7-9.3,33.4C-412.6,141.7-343.9,130.3-349.9,125z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-382.1,28.6 -366.5,28.1 -370.1,10.8 -380.2,11.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-380.2,11.3l10.1-0.5l1.1,5.4c-2.4,2.4-5.7,7.6-9.3,7.3c-1.1-0.1-2.2-0.5-3.1-1.2L-380.2,11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-387.9,16.5c3.2,1.2,7.2,0.9,13.5-1.5c3.6-1.4,7.2-4.8,8.2-7.6l5.8-15.5l-23.9-8.9c-3.1,5-5.2,10.6-6.2,16.4 C-391.4,6-390.4,15.5-387.9,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-358.1-5.2c1.8-4.9-0.7-10.3-5.5-12.1l-8.1-3c-2.3-0.9-4.3-2.3-5.9-4.1c-2.2-2.8-6-3.4-9-1.6 c-3.2,2.1-5.5,5.5-1.5,11.1c2,2.7,6.6,2.2,8.9,4.1c0.2,0.1,0.3,0.1,0.5,0.1l7.1,2.7c2.5,1,3.7,3.7,2.8,6.2 c-0.5,1.6,0.3,3.3,1.9,3.9l0.3,0.1l2.5-3.2l2,6.8L-358.1-5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-444.6,102.9c0,0,8.8-1.7,10.2,0.9s1.9,4.5-1.7,6.7s-9.6,3.5-13.3,3.5s-10-2.5-10.5-3.2 c-1.8-2.6,7.4-5.3,10.7-5.1s4.6,3.3,4.3,1.7s-6.7-1.4-7.8-3.1C-453.8,102.4-444.6,102.9-444.6,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-382.4-16.7c-0.5,3.8-2.4,5.3,7.1,15.2s14.1,8.9,15.5,16.2c0,0,2.1-10.5-3.1-16.3S-378.4-13.8-379-23 C-378.9-22.9-382-19.3-382.4-16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-350.7,32.9V34c0,0.4-0.1,0.7-0.1,1.1c-0.1,0.7-0.2,1.4-0.2,2.1c-0.2,1.4-0.4,2.7-0.7,4 c-0.6,2.7-1.3,5.3-2.1,7.8c-1.7,5.1-4,10-6.7,14.6c-2.8,4.6-6,8.9-9.6,12.8c-3.6,3.9-7.5,7.4-11.8,10.6 c-8.4,6.2-17.7,11.2-27.6,14.7c-1.2,0.5-2.4,0.9-3.7,1.3l-3.7,1.2c-2.5,0.7-5,1.4-7.5,2l-7.6,1.6l-7.6,1.2 c-0.6,0.1-1.2-0.3-1.3-0.9c-0.1-0.6,0.3-1.2,0.9-1.3l0,0c9.9-2.2,19.5-5.3,28.8-9.2l3.4-1.5c1.2-0.5,2.2-1.1,3.4-1.7 s2.2-1.1,3.3-1.7l3.2-1.9c4.3-2.5,8.3-5.4,12.1-8.6c3.8-3.2,7.3-6.6,10.5-10.3c3.1-3.7,5.9-7.8,8.3-12c2.4-4.2,4.3-8.7,5.7-13.3 c0.8-2.3,1.4-4.6,1.8-7c0.2-1.2,0.4-2.3,0.6-3.5c0.1-0.6,0.2-1.1,0.2-1.7c0-0.3,0.1-0.6,0.1-0.8v-1c0.1-2.2,2-3.9,4.2-3.8 c0,0,0,0,0,0C-352.2,29-350.6,30.8-350.7,32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-380.4-15.2c0,0-4.9,11.8-17.5,13.6c0,0,8-7.3,9.9-13.3S-378.1-19-380.4-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-420.1,127c0,0,4.7-6.3,7.3-4.5s4.2,3.5,3.2,7.5c-1.1,4-3.4,7.7-6.5,10.5c-2.4,2-8.3,2.8-9,2.3 c-2.9-1.7,2-4.6,4.3-6.2s4.6-3.7,3.3-5.1s-5.3,2.1-7.1,1S-420.1,127-420.1,127z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-341.5,347.2c-3.4,2.8-7,5.2-10.8,7.3c-0.4,0.2-0.8,0.6-1,1c-2.4,4.5-3.1,8.3-0.2,9.2c1,0.3,15-5.6,21.7-19 c0.3-0.6,3,4.3,3,4.3l4.6-2.7c0,0-2.1-9.2-3.7-10.4l-2.8-2.3C-333.8,339.2-337.4,343.4-341.5,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-361.5,5.9c-2,2.6-4.8,3.7-6.3,2.5s-0.6-5.8,1.4-8.4s4.3-2.1,5.8-0.9S-359.6,3.3-361.5,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-603.5,325.1l-2,16.2c-0.1,0.7-0.3,1.4-0.6,2.1l-2.4,5.5c-1.3,2.8-0.1,6.1,2.7,7.4c0.6,0.3,1.2,0.4,1.8,0.5 c0,0,7,1.2,14.3,2.3s15.9-2.4,15.6-4.2c-0.7-4.1-4-0.2-11.1-3.4c-2.4-1.1-4.9-2.2-7.1-3.4c-6.3-3.4-3.4-15.2-1-22 c0.7-2-0.4-4.2-2.5-4.9c-0.3-0.1-0.7-0.2-1-0.2l-1.7-0.1C-601,320.8-603.1,322.6-603.5,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-610,350.5l32.7,2.4c0,0,6.9,5.1,5.2,8.7c-1.7,3.6-37.5-3.6-37.5-3.6S-614.6,353.8-610,350.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-606.6,140.7l51.9-0.8c0,0,2.3,40.1-16,111.2c-8.6,33.3-21,96.9-21,96.9c-3.3,1.2-15.5,1.4-18.7,0.3 c3.3-19.6,5.6-39.4,6.8-59.2c1.6-29.4,3.7-60.8,2.7-71.2C-603.1,196.5-606.6,140.7-606.6,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-487.8,131.6c-2.2-1.5-4.3-3.2-5.2-3.7c-0.7-0.2-1.4-0.4-2.1-0.5c-1.1-0.2-2.8-0.4-3.5-1.2l-3-3.2 c-1.1-1.5-3.3-1.9-4.8-0.7c-0.2,0.1-0.3,0.3-0.5,0.4l0,0c-2.1,1.8-1.7,4.1,0.1,5.6l2,2.3c1.4,1.2,2,3,2.7,4.8c1.4,3.5,5,6,8.1,7.7 c2,1,5.2-0.1,9.4-1.8c2.1-0.8,5.1-2.7,2.7-3.4c-2-0.6-8.6,1.6-10.9-3.9c-0.1-0.3-0.4-1,0-1.3c0.9-0.9,2.6,0.8,3.9,1.2 c1.7,0.6,3.1,0.2,3.6-0.4C-484.8,132.7-486.2,132.6-487.8,131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-546.3,22.3c0,0-19.2,52.4-2.1,71.6c10.3,11.6,36.2,30.7,42.2,35.1c0.9,0.6,2,0.5,2.8-0.2 c0.6-0.4,1.2-0.9,1.8-1.4c0.7-0.6,1.3-1.2,1.9-1.9c1-1,1.1-2.6,0.2-3.7c-6.5-7.1-32.2-35.1-34.9-42.8c-3.1-8.8,8.4-63.9-1.2-64.7 C-544,13.6-543.6,10.2-546.3,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M-547.5,324.7l-1.5,13.6c-0.3,2.8-1,5.5-2,8.1l-1.6,4.1c-1.1,2.8,0.2,5.9,3,7c0.5,0.2,0.9,0.3,1.4,0.4 c9.3,1,25.1,2.8,29.2,3.2c0.7,0.1,1.4-0.3,1.5-1c0,0,0,0,0,0c0.8-3.9-10.4-7.9-18.7-12.2c-6.3-3.3-4.6-15.1-3.1-21.9 c0.5-2.2-0.9-4.5-3.1-5c-0.3-0.1-0.6-0.1-0.9-0.1l0,0C-545.4,320.9-547.2,322.6-547.5,324.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-571.5,138l51.5-6.6c0,0,6.7,40.5-3.7,114.8C-528.6,281-536,347.5-536,347.5c-3.1,1.6-13.3,2.1-16.6,1.3 c1.2-20.1,1.3-40.3,0.3-60.5c-1.7-30.1-3-62.2-5.1-72.7C-561.9,194.4-571.5,138-571.5,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-518.5,137.6c-4.5,2.1-14.4,5.3-31.9,5c-23.4-0.4-47.5-0.3-56.2-2c-2.3-0.5-0.6-6.7-0.1-9.1l15.8-119.1 l11.5-4.5l11.1,1.6l16.1,82.9l9.9-79l6.6,1l19.7,118.5C-515.7,134.8-516.7,136.7-518.5,137.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-542.3,13.3 -552.2,92.3 -568.2,9.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-547.9-40.4c-10.4-0.7-14.7,6.5-15.8,20.1c-0.4,5.1,1.6,10.3,3.2,13.7c1.2,2.5,1.4,5.4,0.5,8l-2.8,7.6 c-2,7.1,1.1,11.2,6.1,13c2.6,0.8,5.4,0.6,7.7-0.8c2.7-1.5,3.1-5.1,2.8-8.1l-0.4-2.2c-0.6-3,1.3-5.9,4.2-6.6c0.1,0,0.1,0,0.2,0 c8.1-1.2,9.8-9.5,12.8-22.3C-526.4-31.4-537.5-39.7-547.9-40.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-547.8-48c-7.2-0.5-19.4,2.8-18.5,13.3l0.9,7.4c0.4,3,2.6,5.3,5.6,5.8l0,0c0.2,1,1.1,1.8,2.1,1.9 c1.3,0.1,2.4-0.9,2.5-2.2c0,0,0,0,0,0l0,0c0.2-3.3,2.7-6,6-6.5c4.2-0.7,8.5-0.4,12.6,0.9c8,2.7,18.5-10.1,18.5-10.3 c0,0-4.3,2.9-12.3-0.6S-534.5-47.6-547.8-48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-558-19.6c-0.2,3.2-1.5,5.7-4.6,5.5s-4.7-4.7-4.5-7.9s2.2-3.8,5.3-3.6S-557.8-22.8-558-19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M-560.8-6c0,0,7.6,10.8,17.3,9.5c-1.1,0.5-2,1.4-2.5,2.5C-546.1,6-555.2,5.2-560.8-6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-553.6,352.3l30.6,2.9c0,0,9.4,1.7,8,5.4c-1.4,3.7-37.6-0.8-37.6-0.8S-558,355.9-553.6,352.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M-444.9,104.8c-3.1-0.6-6.1-1.4-7.4-1.5c-0.5,0-1.9,0.3-2.4,0.3c-1.2,0.2-3.1,0.7-4.2,0.2l-4.8-2 c-2.3-1-4.6-0.6-5.6,1.7l0,0c-1.1,2.5,0.6,4.6,3.2,5.4l3.4,1.4c2.1,0.6,3.7,2.1,5.4,3.6c3.4,2.9,8.4,3.9,12.6,4.3 c2.6,0.3,5.2-2,8.6-5.3c1.6-1.6,3.7-4.6,0.8-4.3c-2.4,0.2-7.8,4.8-13.2,0.4c-0.3-0.2-0.9-0.8-0.8-1.2c0.5-1.2,3.1-0.3,4.6-0.3 c2.1,0,3.3-0.9,3.5-1.8C-441.2,104.7-442.7,105.2-444.9,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-591.1,21.1c0,0,34.2,58.9,62.3,70.9c17,7.2,54.1,15.8,62.7,17.7c1.1,0.2,2.2-0.2,2.8-1.2 c0.4-0.7,0.7-1.4,1-2.1c0.3-0.8,0.6-1.7,0.8-2.6c0.4-1.5-0.4-3-1.8-3.6c-10.6-4.3-52.4-21.5-59.5-27.8c-8.2-7.3-40.2-57.9-50-62.8 S-595.1,8.5-591.1,21.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -542.2,
    y1: 12.3,
    x2: -542.3,
    y2: 13.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -568.2,
    y1: 9.4,
    x2: -569.4,
    y2: 3.6
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 240.2,
    cy: 156.6,
    r: 156.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.3,134.4c-1.7,1.7-4.5,1.6-6.2-0.1l-30.7-32.2c-1.7-1.7-1.6-4.5,0.1-6.2l25.7-24.6 c1.7-1.7,4.5-1.6,6.2,0.1l30.7,32.2c1.7,1.7,1.6,4.5-0.1,6.2L166.3,134.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.2,102.1c2.5,3.2,1.9,7.8-1.3,10.3c0,0,0,0,0,0l-59,45.3c-3.2,2.5-7.8,1.9-10.3-1.3c0,0,0,0,0,0 l-36.2-47.2c-2.5-3.2-1.9-7.8,1.3-10.3c0,0,0,0,0,0l59-45.3c3.2-2.5,7.8-1.9,10.3,1.3L431.2,102.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 271.3,
    cy: 63.1,
    r: 24.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 66.8,
    cy: 239.9,
    r: 24.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M433.8,231.8c-11.9,2.7-23.8-4.8-26.5-16.7c-2.7-11.9,4.8-23.8,16.7-26.5c11.9-2.7,23.8,4.8,26.5,16.7 c0,0,0,0,0,0C453.2,217.2,445.7,229.1,433.8,231.8z M424.1,189.5c-11.5,2.6-18.6,14-16,25.5c2.6,11.5,14,18.6,25.5,16 s18.6-14,16-25.5c0,0,0,0,0,0C447,194.1,435.6,186.9,424.1,189.5L424.1,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.6,156.5c-13.4-14-12.9-36.2,1.1-49.6S49.9,94,63.3,108c13.4,14,12.9,36.2-1.1,49.6 C48.2,170.9,26,170.5,12.6,156.5z M62.7,108.6C49.7,94.9,28,94.4,14.3,107.5s-14.2,34.7-1.1,48.4c13.1,13.7,34.7,14.2,48.4,1.1 C75.2,143.9,75.7,122.3,62.7,108.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M434.7,72.1c-20.6-9.2-40.1,34.2-81.3,57.8c-17.8,10.2-46.7,26.6-84.5,21l2.5,12.1l-8.3,21.2 c5.6,4,59.8,21.5,132.4-26.8c50.1-33.3,54.4-46.6,54.7-55.6C450.5,90.1,444.1,76.3,434.7,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.3,166.4c0.6-8.2-5.8-13.6-11-18c-5.7-4.9-18.1-0.4-29.9-11.7c-2.6-2.5-4-6.1-5.9-5.2 c-1.7,0.7-2.7,4.1-3,6.4c-0.8,5.9,1.9,10.4,7.5,18.9c7.5,11.5,11.2,17.2,12.5,18.3c3.6,3.1,13.5,11.7,22.2,5.1 C301.1,177.6,304.9,172.2,305.3,166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M295.8,149.4c-6.8-4.7-14.1-3.9-27.3-2.6c-8.6,0.8-25.2,3.2-32.2,2.6c-6.3-0.6-18.7,10.1-19.3,11.1 c-3.3,6.6,5.7,20.2,16.8,31.6c5.1,5.3,32.9,19.3,55.8,4c1.9-1.3,16.4-11.2,17.6-25.1C308.2,158.3,297.3,150.4,295.8,149.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M165.1,155.1c2.1-7.6,12.3-10.5,20.7-12.8c9.2-2.6,23.7,5.4,43.1-1.1c4.3-1.4,7.3-4.2,9.5-2.8 c1.9,1.2,2,4.6,1.6,6.8c-1,5.6-6.1,8.8-16.3,14.7c-13.8,8-20.6,12-22.8,12.6c-5.7,1.7-21.7,6.3-30.8-2.4 C166.6,166.6,163.5,160.5,165.1,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.4,142.7c10.4-2.1,19.8,0.9,36.5,6.3c10.9,3.5,12.9,5.3,19.6,5.5c9.8,0.3,11.7-3.5,21.1-1.8 c6.1,1.2,11.8,3.8,16.7,7.6c2.6,2,4,3,4.3,4.1c2,7-17.4,21.1-35.8,28c-8.5,3.2-46.2,15.8-70.8-5.4c-2.1-1.8-17.5-15.4-14.1-28.4 C164.1,146.8,181.1,143.1,183.4,142.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,88.1l77.4,31.5l63.1,16.3c0,0-1.3,21.8-1.8,29c-0.9,14.9-14.5,28.3-14.5,28.3s-44.9-7.3-59.3-11.2 c-25.4-6.7-98-33.9-98-33.9s-2.2-29.3,3-37.8C21.4,103.1,47.2,88.1,47.2,88.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M34.4,70.2l77,37.4l62.9,18.9c0,0-1.7,26.9-2.3,35.9c-1.2,18.4-15,35.2-15,35.2s-44.8-8.2-59.2-12.7 c-25.3-7.8-97.6-40.1-97.6-40.1S-1.4,108.7,3.9,98C8.4,89.1,34.4,70.2,34.4,70.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake3);
export default __webpack_public_path__ + "static/media/handshake-3.6c8a1fb9aca22853e3c3b44d298b09a4.svg";
export { ForwardRef as ReactComponent };